module.exports = __webpack_public_path__ + "img/rili_blue.ec5865ae.png";